import LoadingOverlay from 'react-loading-overlay';
import RainbowBanner from './RainbowBanner';
import React, {PropTypes} from 'react';

export default function MainContent({children, hideRainbow, loading}) {
  return (
    <div className={`main-content ${loading ? 'loading' : ''}`}>
      { hideRainbow
        ? <div />
        : <RainbowBanner />
      }
      {loading && <LoadingOverlay active={loading} text="Loading..." className="loading-overlay" />}
      {!loading && children}
    </div>
  );
}

MainContent.defaultProps = {
  hideRainbow: false,
};

MainContent.propTypes = {
  children: PropTypes.oneOfType([
    PropTypes.element,
    PropTypes.arrayOf(PropTypes.element),
  ]),
  hideRainbow: PropTypes.bool,
  loading: PropTypes.bool,
};



// WEBPACK FOOTER //
// ./app/features/layout/components/MainContent.js